define('app/views/menu-list',['require','./page'],function(require){

  var Page = require('./page');

  return Page.extend({

    view: 'menu_list',

    events: {
      'click nav a': 'onClickMenu'
    },

    initialize: function(options){
      Page.prototype.initialize.call(this, options);

      _.bindAll(this, 'onClickMenu');
    },

    reset: function(){
      $('.blurb', this.$el).show();
      $('.menu', this.$el).hide();
      $('a', this.$el).removeClass('active');
    },

    beforeShow: function(){
      Page.prototype.beforeShow.call(this);

      if(this.model.get('TEMPLATE') == 'menu_list'){
        $('.blurb', this.$el).show();
        $('.menu', this.$el).hide();
      } else {
        $('a[data-id="' + this.model.id + '"]');
        $('.menu').hide().filter('[data-parentid="' + this.model.id + '"]').show();
      }
    },

    onClickMenu: function(e){
      //deactivate other nav states and hide all menus
      $('a', this.$el).removeClass('active');
      $('.blurb,.menu').hide();

      //activate correct nav item and get its data
      var data = $(e.target).addClass('active').data();

      $('.menu[data-parentid="' + data.id + '"]').show();
      window.iws.site.router.navigate(data.path, { trigger: false });
    }

  });

});
